import React from 'react';
import { Layout } from '../components/Layout/Layout';
import { LoginForm } from '../components/Auth/LoginForm';

export const LoginPage: React.FC = () => {
  return (
    <Layout showSidebar={false}>
      <LoginForm />
    </Layout>
  );
};
